import {
	API_SEARCH_POSTALCODE,
	API_SEARCH_POSTALCODE_SUCCESS,
	API_SEARCH_POSTALCODE_FAIL
} from '../actions/postalCode';
import { createReducer } from '@reduxjs/toolkit';
import { ErrorAction, errorHandler } from 'utils/error';

const initialState = {
	loading: false,
	list: [],
	countries: []
};

const postalcodes = createReducer(initialState, {
	/** SEARCH **/
	[API_SEARCH_POSTALCODE]: (state, action) => {
		state.loading = true;
	},
	[API_SEARCH_POSTALCODE_FAIL]: (state, action) => {
		errorHandler('Code postal', ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_SEARCH_POSTALCODE_SUCCESS]: (state, action) => {
		state.loading = false;
		state.list = action.payload.data;
	},
});

export default postalcodes;
